import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full bg-zinc-200" }
const _hoisted_2 = { class: "mx-2 md:mx-56" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold" }, "Mon Compte", -1)
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = { class: "text-xl font-bold" }
const _hoisted_6 = { class: "text-xs" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Évènements à venir", -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold mt-6" }, "Évènements passés", -1)

import {onMounted } from 'vue'
    import  UserEvent from "@/components/User/UserEvent.vue" 
    import { storeToRefs } from 'pinia'
    import { useUserStore } from '../stores/UserStore'
  
    
export default /*#__PURE__*/_defineComponent({
  __name: 'UserPage',
  props: {
          id: {
            type: Number,
            required: true,
          }
    },
  setup(__props) {

const props = __props;

    const {getEventsByCustomerId } = useUserStore()
    const {userFirstName, userLastName, userPhoneNumber, userEmail, userId, userEventsBefore,userEventsUpcoming} = storeToRefs(useUserStore())

    
    onMounted( () => {
        getEventsByCustomerId(userId.value);
    })
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(userFirstName)) + " " + _toDisplayString(_unref(userLastName)), 1),
        _createElementVNode("p", _hoisted_6, "Email: " + _toDisplayString(_unref(userEmail)), 1)
      ]),
      (_unref(userEventsUpcoming).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userEventsUpcoming), (it) => {
              return (_openBlock(), _createBlock(UserEvent, {
                key: it.eventId,
                eventDescription: it.eventDescription,
                scheduledAt: it.scheduledAt,
                hourCode: it.hourCode,
                eventDuration: it.eventDuration,
                eventPrice: it.eventPrice,
                eventid: it.eventId,
                companyName: it.companyName,
                companyId: it.companyId,
                companyAdress: it.companyAdress,
                companyCity: it.companyCity,
                companyZipCode: it.companyZipCode,
                employeeName: it.employeeName
              }, null, 8, ["eventDescription", "scheduledAt", "hourCode", "eventDuration", "eventPrice", "eventid", "companyName", "companyId", "companyAdress", "companyCity", "companyZipCode", "employeeName"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_unref(userEventsBefore).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userEventsBefore), (it) => {
              return (_openBlock(), _createBlock(UserEvent, {
                key: it.eventId,
                eventDescription: it.eventDescription,
                scheduledAt: it.scheduledAt,
                hourCode: it.hourCode,
                eventDuration: it.eventDuration,
                eventPrice: it.eventPrice,
                eventid: it.eventId,
                companyName: it.companyName,
                companyId: it.companyId,
                companyAdress: it.companyAdress,
                companyCity: it.companyCity,
                companyZipCode: it.companyZipCode,
                employeeName: it.employeeName
              }, null, 8, ["eventDescription", "scheduledAt", "hourCode", "eventDuration", "eventPrice", "eventid", "companyName", "companyId", "companyAdress", "companyCity", "companyZipCode", "employeeName"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})